import get from 'lodash/get';
import 'moment-timezone';
import 'moment/locale/fr-ca';
import moment from 'moment';
import { isFrench } from './lang';

export const toLocalTime = (DateTimeInIsoFormat) => new Date(DateTimeInIsoFormat).toLocaleString('en-us', { hour: 'numeric', minute: 'numeric', hour12: true });

export const currentTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const currentTimezoneAbbr = () => {
  let timezone = get(new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' '), 2, '');
  if (typeof timezone === 'undefined' || !timezone || timezone.length === 0) {
    timezone = '';
  }

  return timezone;
};

export const isLocalTimeSameAsEST = (expectedOffSet) => -new Date().getTimezoneOffset() / 60 === expectedOffSet;

moment.locale(isFrench() ? 'fr-ca' : 'en-us', {
  week: {
    dow: 1, // Monday is the first day of the week
  },
});

moment.tz.setDefault('America/Montreal');

export const localizedMoment = moment;
